import { css } from '@emotion/react';
import { parseToHsl, hsl, darken } from 'polished';

export default $ => {
  const height = $.themeHeight || '24px';
  const gap = $.themeGap || '4px';
  const width = `calc(2 * ${height})`;

  return css`
    .switch {
      position: relative;
      display: inline-block;
      width: ${width};
      height: ${height};
      vertical-align: middle;
      margin-left: ${gap};
      margin-right: ${gap};

      > input {
        opacity: 0;
        width: 0;
        height: 0;
      }

      &.round > .slider {
        border-radius: ${height};
        &:before {
          border-radius: 50%;
        }
      }

      --slider-bg: #ccc;
      --slider-checked-bg: #2196f3;
      --slider-border-readonly-bg: #ced4da; /* adjusted from scale-color(#2196F3, $saturation: -80%, $lightness: 10%) */
      --slider-button-readonly-bg: #ffffff; /* adjusted from scale-color(#2196F3, $saturation: -80%, $lightness: 10%) */
      --slider-checked-readonly-bg: #f5f5f5; /* adjusted from scale-color(#2196F3, $saturation: -80%, $lightness: 10%) */
      --slider-button: white;

      > .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: var(--slider-bg);
        -webkit-transition: 0.4s;
        transition: 0.4s;

        &:before {
          position: absolute;
          content: '';
          height: calc(${height} - 2 * ${gap});
          width: calc(${height} - 2 * ${gap});
          left: ${gap};
          bottom: ${gap};
          background-color: #f0000040;
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }

        &.enabled:before {
          position: absolute;
          content: '';
          height: calc(${height} - 2 * ${gap});
          width: calc(${height} - 2 * ${gap});
          left: ${gap};
          bottom: ${gap};
          background-color: ${$.primaryMain};
          -webkit-transition: 0.4s;
          transition: 0.4s;
        }
      }

      &.readonly > .slider {
        background-color: var(--slider-checked-readonly-bg) !important;
        border: 1px solid var(--slider-border-readonly-bg);
      }

      > input:checked + .slider {
        background-color: var(--slider-checked-bg);
      }

      > input:focus + .slider {
        // box-shadow: 0 0 1px var(--slider-checked-bg);
      }

      > input:checked + .slider:before {
        transform: translateX(calc(${width} - ${height}));
      }
    }

    ${css(
      Object.entries($.themeColors).map(
        ([name, color]) => `
      .switch-${name} {
        --slider-checked-bg: ${color};
        // --slider-bg: ${adjustColor(color, -90, +20)};
      }
    `
      )
    )}
  `;
};

function adjustColor(color, hue, ligthness) {
  const hslColor = parseToHsl(color);
  hslColor.hue += hue;
  hslColor.ligthness += ligthness;

  return hsl(hslColor);
}
